// motiongraphics.v2 holds both Motion Graphics rows (`is_lut:false`) and
// LUTs (`is_lut:true`). This filter scopes a query to the MG side. See
// LUTS_FILTER for the complementary half.
export const MOTION_GRAPHICS_FILTER = 'is_lut:false';
